import React from 'react';
import "./../css/components/Sucursal.css"

function Inicio({suc, id}) {
  return <section className={ 'sucursal'}>
    <img src={suc.img} className='sucursal__img'/>    
    <div className='sucursal__contenido'>
      <h2 className='sucursal__contenido__titulo'>{suc.name}</h2>
      <h4 className='sucursal__contenido__texto'><b>Telefono: </b>{suc.phone}</h4>  
      <h4 className='sucursal__contenido__texto'><b>Dirección: </b>{suc.address}</h4> 
    </div>    
  </section>;
}

export default Inicio;